var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkTutorial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 77,
    viewBox: "0 0 88 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.764 60.6174C46.2294 62.7917 41.7707 62.7917 38.2324 60.6174L14.6667 46.1157V66.0001C14.6667 72.0757 19.591 77.0001 25.6667 77.0001H62.3334C68.409 77.0001 73.3334 72.0757 73.3334 66.0001V46.1157L49.764 60.6174Z",
    fill: "url(#paint0_linear_334_23146)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.236 9.04927L7.47632 27.9766C2.36499 31.1226 2.36499 38.5476 7.47632 41.6936L38.2323 60.6209C41.767 62.7953 46.2257 62.7953 49.764 60.6209L80.52 41.6936C85.6313 38.5476 85.6313 31.1226 80.52 27.9766L49.764 9.04927C46.2293 6.87127 41.7707 6.87127 38.236 9.04927Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3256 30.912L68.178 20.3792C66.5684 14.8132 61.204 16.0892 61.204 16.0892L45.6561 25.8074C45.1239 25.7153 44.5696 25.6666 44 25.6666C39.9499 25.6666 36.6667 28.129 36.6667 31.1666C36.6667 34.2041 39.9499 36.6666 44 36.6666C48.0501 36.6666 51.3334 34.2041 51.3334 31.1666C51.3334 31.0812 51.3308 30.9964 51.3256 30.912Z",
    fill: "url(#paint1_linear_334_23146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_23146",
    x1: 44,
    y1: 46.1157,
    x2: 44,
    y2: 77.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_23146",
    x1: 52.4224,
    y1: 15.9631,
    x2: 52.4224,
    y2: 36.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555555"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTutorial);
export default __webpack_public_path__ + "static/media/dark-tutorial.5df5222bf8163d7e755d16600295c9df.svg";
export { ForwardRef as ReactComponent };